import React, { Component } from 'react';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
	WithStyles,
	createStyles,
	Card,
	CardContent,
	Avatar,
	Grid,
	Typography,
	Tooltip,
	Button,
	Menu,
	MenuItem,
	FormControlLabel,
	Radio,
} from '@material-ui/core';
import {
	Group as GroupIcon,
	Edit as EditIcon,
	DeleteOutline as DeleteIcon,
	MoreVert as MoreIcon,
	RemoveCircle as RemoveIcon,
	AddCircle as AddIcon,
	Close as CloseIcon,
	RemoveRedEye as ViewIcon,
} from '@material-ui/icons';
import { MyPATExpansionPanel, MyPATIconButton, MyPATDialog } from '../../common';
import GroupIconGrid from '../components/GroupIconGrid';
import UserGroupIcon from '../../../assets/svg/UserGroup';

import userGroupsServices from '../services/userGroupsServices';
import { userGroupsList, getUserGroupsCount, removeRole } from '../actions/userGroupsActions';
import { UserGroupsBody } from '../types/UserGroupsBody';
import UserReviewerGrid from '../components/UserReviewerGrid';
import UserProfileCard from '../components/UserProfileCard';
import { usersList } from '../actions/usersActions';
import AssignGroupRoleDialog from '../components/AssignGroupRoleDialog';
import ACL from '../../acl/components/ACL';
import ACLService from '../../acl/services/aclService';

const styles = (theme: Theme) => createStyles({
	textCenter: {
		textAlign: 'center',
	},
	textCapitalize: {
		textTransform: 'capitalize'
	},
	mb1x: {
		marginBottom: theme.spacing.unit,
	},
	mb1x5x: {
		marginBottom: theme.spacing.unit * 1.5,
	},
	mr2x: {
		marginRight: theme.spacing.unit * 2,
	},
	fwNormal: {
		fontWeight: theme.typography.fontWeightRegular,
	},
	cardContentRoot: {
		position: 'relative',
		...theme.mixins.gutters(),
		paddingTop: theme.spacing.unit * 2,
		paddingBottom: theme.spacing.unit * 2,
		'&:last-child': {
			paddingBottom: theme.spacing.unit * 2,
		},
	},

	roleName: {
		display: 'inline-block',
		textTransform: 'capitalize',
		marginRight: theme.spacing.unit / 2,
		'&:after': {
			content: '","',
		},
		'&:last-child': {
			marginRight: 0,
			'&:after': {
				display: 'none',
			}
		}
	},
	groupIcon: {
		borderRadius: "50%",
		color: theme.palette.primary.main,
		border: `1px solid ${theme.palette.primary.main}`,
		padding: theme.spacing.unit * 1.5,
		width: theme.spacing.unit * 8.5,
		height: theme.spacing.unit * 8.5,
	},
	userGroupGridBox: {
		paddingTop: theme.spacing.unit,
		paddingBottom: theme.spacing.unit,
	},
	descriptionBox: {
		paddingLeft: `${theme.spacing.unit}px !important`,
		borderLeft: `1px solid ${theme.palette.grey[400]}`,
	},
	iconBox: {
		paddingRight: `${theme.spacing.unit * 2.5}px !important`,
	},

	bigAvatar: {
		height: theme.spacing.unit * 7,
		width: theme.spacing.unit * 7,
	},
	profileWrapper: {
		marginRight: theme.spacing.unit,
	},

	moreMenu: {
		'& li': {
			height: theme.spacing.unit * 2,
			color: theme.palette.text.secondary,
			fontSize: '0.8rem',
			paddingTop: theme.spacing.unit,
			paddingBottom: theme.spacing.unit,
			'& > svg': {
				marginRight: theme.spacing.unit,
				fontSize: '1rem',
			}
		}
	},

	dialogCloseContainer: {
		textAlign: 'right',
	},
	groupGrid: {
		display: 'flex',
		alignItems: 'center',
		'& > svg': {
			fontSize: theme.spacing.unit * 5.5,
			color: theme.palette.primary.main,
			marginRight: theme.spacing.unit * 2,
		},
		'& > .groupName': {
			color: theme.palette.grey[500],
		}
	},
	removeRoleBtn: {
		float: "right",
	},
	rolesAndLibrariesList: {
		margin: 0,
		paddingLeft: theme.spacing.unit * 3,
		fontFamily: theme.typography.fontFamily,
		'& > li': {
			marginBottom: theme.spacing.unit,
		}
	},
	rolesList: {
		margin: 0,
		padding: 0,
		listStyle: 'none',
		'& > li': {
			marginBottom: theme.spacing.unit,
			'&.radioLabel': {
				'& > span': {
					padding: `${theme.spacing.unit / 2}px ${theme.spacing.unit}px`,
				},
				'& > .libraryName': {
					marginLeft: theme.spacing.unit * 4.5,
				}
			},
			'&.controlLabel': {
				'& > label': {
					marginLeft: 0,
					'& > span:first-child': {
						padding: `${theme.spacing.unit / 2}px ${theme.spacing.unit}px`,
					},
					'& > span:last-child': {
						...theme.typography.body1,
					}
				},
				'& > .libraryName': {
					marginLeft: theme.spacing.unit * 4.5,
				}
			}
		}
	},
});

interface UserGroupsContainerProps extends WithStyles<typeof styles> {
	userGroups: {
		list: UserGroupsBody[],
		count: number,
	},
	userGroupsList: () => void,
	getUserGroupsCount: () => void,
	onEditClick: () => void,
	usersList: () => void,
	handleShowUserProfile: (userProfile: any) => void,
	assignRoleDialogOpen: boolean,

}

interface UserGroupsContainerState {
	isDeleteDialogOpen: boolean,
	deleteId: string,
	deleteName: string,
	anchorEl: any,
	openMenu: string,
	showUserProfile: boolean,
	selectedUserProfile: any,
	showAssignRoleGroup: boolean,
	selectedUserGroup: any,
	showRemoveRole: boolean,
	selectedRemoveRoleId: string,
	showGroupRole: boolean
}

class UserGroupsContainer extends Component<UserGroupsContainerProps, UserGroupsContainerState> {
	constructor(props: UserGroupsContainerProps) {
		super(props);
		this.state = {
			isDeleteDialogOpen: false,
			deleteId: '',
			deleteName: '',
			anchorEl: null,
			showUserProfile: false,
			selectedUserProfile: {},
			openMenu: '',
			showAssignRoleGroup: false,
			selectedUserGroup: {},
			showRemoveRole: false,
			selectedRemoveRoleId: "",
			showGroupRole: false
		};

		this.handleConfirmDelete = this.handleConfirmDelete.bind(this);
		this.handleConfirmDeleteDialogOpen = this.handleConfirmDeleteDialogOpen.bind(this);
		this.handleConfirmDeleteDialogClose = this.handleConfirmDeleteDialogClose.bind(this);
		this.handleMoreMenuClose = this.handleMoreMenuClose.bind(this);
		this.handleAssignRoleOpen = this.handleAssignRoleOpen.bind(this);
	}

	handleMoreMenuOpen = (evt: any, target: string) => {
		evt.stopPropagation();
		this.setState({ anchorEl: evt.currentTarget, openMenu: target });
	};

	handleMoreMenuClose = (evt: any) => {
		evt.stopPropagation();
		this.setState({ anchorEl: null, openMenu: '' })
	};

	handleConfirmDeleteDialogOpen = (deleteId: string, deleteName: string, evt: any) => {
		evt.stopPropagation();
		this.handleMoreMenuClose(evt);
		this.setState({
			isDeleteDialogOpen: true,
			deleteId,
			deleteName,
		});
	};

	handleConfirmDeleteDialogClose = () => this.setState({
		isDeleteDialogOpen: false,
		deleteId: '',
		deleteName: '',
	});

	handleConfirmDelete = (evt: any) => {
		userGroupsServices.remove(this.state.deleteName, this.state.deleteId).then(res => {
			this.props.userGroupsList();
			this.props.getUserGroupsCount();
			this.handleConfirmDeleteDialogClose();
		});
	};

	showUserProfile = (userProfile: any, e: any) => this.setState({ selectedUserProfile: userProfile, showUserProfile: true });

	handleUserProfileClose = () => {
		this.setState({ showUserProfile: false, selectedUserProfile: {} });
		this.props.usersList();
		this.props.userGroupsList();
	};

	handleAssignRole = () => { this.setState({ showAssignRoleGroup: false }); this.props.userGroupsList(); };

	handleAssignRoleOpen = (userGroup: any, e: any) => {
		e.stopPropagation();
		let { showAssignRoleGroup, selectedUserGroup } = this.state;
		showAssignRoleGroup = true;
		selectedUserGroup = userGroup;
		this.setState({ showAssignRoleGroup, selectedUserGroup })
	}

	handleRemoveRole = (userGroup: any, e: any) => {
		e.stopPropagation();
		let { showRemoveRole, selectedUserGroup } = this.state;
		showRemoveRole = true;
		selectedUserGroup = userGroup;
		this.setState({ showRemoveRole, selectedUserGroup })
	}

	handleRemoveRoleClose = (e: any) => {
		this.setState({ showRemoveRole: false, selectedUserGroup: {} });
		this.props.userGroupsList();
	}

	changeSelectedRoleId(e: any) {
		let { selectedRemoveRoleId } = this.state;
		let { name, value } = e.target;
		selectedRemoveRoleId = value;
		this.setState({ selectedRemoveRoleId });
	}

	removeGroupRole(e: any) {
		let { selectedRemoveRoleId, selectedUserGroup } = this.state;
		if (!_.isUndefined(selectedUserGroup._id) && selectedRemoveRoleId) {
			let groupId = selectedUserGroup._id;
			let ids = selectedRemoveRoleId.split('_');
			removeRole(groupId, ids[0], ids[1])
				.then((res: any) => {
					if (res == 200) {
						this.setState({ selectedRemoveRoleId: "", showRemoveRole: false, selectedUserGroup: {} });
						this.props.usersList();
						this.props.userGroupsList();
					}
				})
		}
	}

	handleViewRole = (userGroup: any, e: any) => {
		e.stopPropagation();
		let { showGroupRole, selectedUserGroup } = this.state;
		showGroupRole = true;
		selectedUserGroup = userGroup;
		this.setState({ showGroupRole, selectedUserGroup })
	}


	handleRoleView = (e: any) => this.setState({ showGroupRole: false });


	render() {
		const { anchorEl, isDeleteDialogOpen, deleteName, openMenu, showUserProfile, selectedUserProfile, showAssignRoleGroup, selectedUserGroup, showRemoveRole, selectedRemoveRoleId, showGroupRole } = this.state;
		const { classes, userGroups, onEditClick, assignRoleDialogOpen, } = this.props;

		return (
			<>
				{_.map(userGroups.list, userGroup => (
					<MyPATExpansionPanel
						key={`userGroup-${userGroup._id}`}
						defaultExpanded={false}
						variant="white"
						panelProps={{ className: classes.mb1x5x }}
						customCollapseTitle={
							<Grid container alignItems="center" justify="space-between" spacing={8} className={classes.userGroupGridBox}>
								<Grid item xs="auto" className={classes.iconBox}>
									<UserGroupIcon className={classes.groupIcon} style={{ fill: userGroup.groupColor, borderColor: userGroup.groupColor }} />
								</Grid>
								<Grid item xs className={classes.descriptionBox}>
									<Typography variant="h6" className={classes.textCapitalize}>
										{userGroup.name} ({userGroup.usersId.length})
									</Typography>
									<Typography variant="body2">
										Description:
									</Typography>
									<Typography variant="body2" className={classes.fwNormal}>
										{userGroup.description}
									</Typography>
								</Grid>
								<Grid item xs="auto">
									<MyPATIconButton onClick={(e: any) => { this.handleMoreMenuOpen(e, `menu-${userGroup._id}`) }}>
										<MoreIcon />
									</MyPATIconButton>
									<Menu
										id={`menu-${userGroup._id}`}
										anchorEl={anchorEl}
										open={_.isEqual(`menu-${userGroup._id}`, openMenu) ? true : false}
										onClose={(evt: any) => { this.handleMoreMenuClose(evt) }}
										className={classes.moreMenu}
									>
										{/* {
											ACLService.hasAccessTo(['USER'], ['VIEW']) &&
											<MenuItem onClick={(evt: any) => { this.handleViewRole(userGroup, evt) }}>
												<ViewIcon /> View Role(s)
											</MenuItem>
										} */}

										{/* {
											ACLService.hasAccessTo(['USER'], ['UPDATE', 'EDIT']) &&
											<MenuItem id={userGroup._id} onClick={onEditClick}>
												<EditIcon /> Edit
											</MenuItem>
										} */}

										{/* {
											ACLService.hasAccessTo(['USER'], ['DELETE']) &&
											<MenuItem onClick={(e: any) => { this.handleConfirmDeleteDialogOpen(userGroup._id, userGroup.name, e) }}>
												<CloseIcon /> Delete
											</MenuItem>
										} */}

										{/* {
											ACLService.hasAccessTo(['USER'], ['UPDATE', 'EDIT']) &&
											<MenuItem onClick={(evt: any) => { this.handleAssignRoleOpen(userGroup, evt) }}>
												<AddIcon /> Assign Role
											</MenuItem>

										} */}

										{/* {
											ACLService.hasAccessTo(['USER'], ['DELETE']) &&
											<MenuItem onClick={(evt: any) => { this.handleRemoveRole(userGroup, evt) }}>
												<RemoveIcon /> Remove Role
											</MenuItem>
										} */}



									</Menu>
								</Grid>
							</Grid>
						}
					>
						{_.map(userGroup.usersId, user => (
							<Card
								onClick={() => this.props.handleShowUserProfile(user)}
								key={`${user._id}-of-${userGroup._id}`} className={classes.mb1x}>
								<CardContent className={classes.cardContentRoot}>
									<Grid container alignItems="center" spacing={8}>
										<Grid item xs="auto" className={classes.profileWrapper}>
											<Avatar alt={`Profile ${user.fullName}`} src={_.isEmpty(user.profileImage) ? "/assets/img/profile-default.png" : user.profileImage} className={classes.bigAvatar} />
										</Grid>

										<Grid item xs={7}>
											<Typography variant="h5">
												<strong className={classes.textCapitalize}>{user.fullName}</strong>
											</Typography>

											{!_.isUndefined(user.roles) && _.map(user.roles, (role, rIndex) => (
												<Typography key={`role-${rIndex}`} variant="body1" className={classes.roleName}>
													{_.get(role, 'roleId.role', '-')} for {_.get(role, 'miniLibrary.name', '-')}
												</Typography>
											))}
										</Grid>

										<Grid item xs className={classes.mr2x}>
											<UserReviewerGrid
												allReviewers={user.roles}
											/>
										</Grid>

										<Grid item xs="auto" className={classes.textCenter}>
											<GroupIconGrid
												groupColor={userGroup.groupColor}
												groupName={userGroup.name}
												otherGroups={user.groupsId}
											/>
										</Grid>
									</Grid>
								</CardContent>
							</Card>
						))}
					</MyPATExpansionPanel>
				))}

				<MyPATDialog
					dialogOpen={isDeleteDialogOpen}
					otherDialogProps={{
						fullWidth: true,
						maxWidth: 'sm',
					}}
					customDialogActions={
						<>
							<Button color="primary"
								onClick={this.handleConfirmDelete.bind(this)}
							>
								Delete
							</Button>
							<Button
								variant="contained" color="primary"
								onClick={() => this.handleConfirmDeleteDialogClose()}
							>
								Cancel
              </Button>
						</>
					}
				>
					<Typography variant="body1">
						<strong>All content rights and permissions given to the group members through this group will be revoked. Do you want to continue to delete this group?</strong>
					</Typography>
				</MyPATDialog>


				<AssignGroupRoleDialog
					dialogOpen={showAssignRoleGroup}
					dialogCloseHandler={this.handleAssignRole.bind(this, false)}
					selectedUserGroup={selectedUserGroup}
				/>


				<MyPATDialog
					dialogOpen={showRemoveRole}
					variant="white"
					otherDialogProps={{
						fullWidth: true,
						maxWidth: 'sm',
						scroll: 'body'
					}}
					customDialogTitle={
						<Grid container justify="space-between" alignItems="center">
							<Grid item xs>
								<Typography variant="h6">
									Remove Group Roles
								</Typography>
							</Grid>

							<Grid item xs="auto" className={classes.dialogCloseContainer}>
								<MyPATIconButton buttonVariant="flat" onClick={this.handleRemoveRoleClose.bind(this)}>
									<CloseIcon />
								</MyPATIconButton>
							</Grid>
						</Grid>
					}
				>
					<Grid container alignItems="center">
						<Grid item xs={12} className={classes.mb1x}>
							<Typography variant="body1" gutterBottom>
								<strong>Group</strong>
							</Typography>
							<div className={classes.groupGrid}>
								<GroupIcon />
								<Typography variant="h6" className="groupName">{selectedUserGroup.name} ({!_.isUndefined(selectedUserGroup.usersId) && selectedUserGroup.usersId.length || 0})</Typography>
							</div>
						</Grid>

						<Grid item xs={12} className={classes.mb1x}>
							<Typography variant="body1" gutterBottom>
								<strong>Select Role to Remove</strong>
							</Typography>
							<ul className={classes.rolesList}>
								{
									_.map(selectedUserGroup.roles, (role, i) => (
										<li key={`li-role-remove-${i}`} className="controlLabel">
											<FormControlLabel
												control={<Radio checked={selectedRemoveRoleId == `${role.roleId._id}_${role.miniLibrary._id}`} color="primary" />}
												value={`${role.roleId._id}_${role.miniLibrary._id}`}
												label={!_.isUndefined(role.roleId.role) ? role.roleId.role : ""}
												name="groupRole"
												key={`radio-role-remove-${role._id}`}
												onChange={this.changeSelectedRoleId.bind(this)}
											/>
											<Typography variant="body1" className="libraryName">{!_.isUndefined(role.miniLibrary.name) ? role.miniLibrary.name : ""}</Typography>
										</li>
									))
								}

							</ul>
						</Grid>
						<Grid item xs={12} >
							<Button variant="contained" color="primary" className={classes.removeRoleBtn}
								onClick={this.removeGroupRole.bind(this)}
								disabled={_.isEmpty(selectedRemoveRoleId) ? true : false}
							>
								Remove Role
						        </Button>
						</Grid>
					</Grid>
				</MyPATDialog>

				<MyPATDialog
					dialogOpen={showGroupRole}
					variant="white"
					otherDialogProps={{
						fullWidth: true,
						maxWidth: 'md',
						scroll: 'body'
					}}
					customDialogTitle={
						<Grid container justify="space-between" alignItems="center">
							<Grid item xs>
								<Typography variant="h6">
									Group Roles
								</Typography>
							</Grid>

							<Grid item xs="auto" className={classes.dialogCloseContainer}>
								<MyPATIconButton buttonVariant="flat" onClick={this.handleRoleView.bind(this)}>
									<CloseIcon />
								</MyPATIconButton>
							</Grid>
						</Grid>
					}
				>
					<Grid container alignItems="center">
						<Grid item xs={12} className={classes.mb1x}>
							<Typography variant="body1" gutterBottom>
								<strong>Group</strong>
							</Typography>
							<div className={classes.groupGrid}>
								<GroupIcon />
								<Typography variant="h6" className="groupName">{selectedUserGroup.name} ({!_.isUndefined(selectedUserGroup.usersId) && selectedUserGroup.usersId.length || 0})</Typography>
							</div>
						</Grid>

						<Grid item xs={12} className={classes.mb1x}>
							<Typography variant="body1" gutterBottom>
								<strong>Roles and Libraries</strong>
							</Typography>
							<ol className={classes.rolesAndLibrariesList}>

								{
									_.map(selectedUserGroup.roles, (role, i) => (
										<li key={`roleView-${i}`}>
											<Typography key={`roleName-${i}`} variant="body1">{!_.isUndefined(role.roleId.role) ? role.roleId.role : ""}</Typography>
											<Typography key={`roleBody-${i}`} variant="body1" color="textSecondary">{!_.isUndefined(role.miniLibrary.name) ? role.miniLibrary.name : ""}</Typography>
										</li>
									))
								}


							</ol>
						</Grid>
					</Grid>
				</MyPATDialog>
			</>
		);
	}
}

const mapStateToProps = (state: any) => ({
	userGroups: _.get(state, 'userManagement.userGroups', {}),
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
	userGroupsList,
	getUserGroupsCount,
	usersList,
}, dispatch);

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(UserGroupsContainer));